define(
    'widgets/fp_treeview_folder/viewmodel',[
        'durandal/app',
        'providers/dataprovider',
        'i19n!i19n/strings'
    ],
    function (app, dataProvider, i19n) {
        var ctor = function () { };

        ctor.prototype.activate = function (settings) {
            var self = this;

            self.i19n = i19n;
            self.settings = settings;
            self.id = settings.data.id;

            self.$treeview = null;
            self.treeview = null;

            self.showCollapsed = ko.observable(false);
            self.isCollapsible = function () { return self.$treeview.find(".k-item .k-item:has(span.k-minus) .k-item:visible").length > 0; };
            self.isCollapseExpandVisible = ko.observable(false);
            self.isShowAllVisible = ko.observable(settings.data.isShowAllVisible);

            self.state = 0;

            self.isCollapsingExpanding = false;
            self.initialized = ko.observable(false);

            self.folderIcon = {
                open : 'fa-folder-open-o',
                close: 'fa-folder-o'
            };

            self.nodeAdd = function (callbacks) {
                $("#dd-id" + self.id).css({ display: "none" });
                $("#all-id" + self.id).css({ display: "none" });

                if (self.state)
                    return;

                self.state = 1;

                var s = self.treeview.select(); s = s.length > 0 ? s : null;
                var n = self.treeview.append({}, s);

                var $textbox = $('<input style="position:absolute;top:-1px; left:18px;" class="addnode" type="text" size="12" value="' + self.i19n.to.newfolder + '">');
                var $icon = $('<i style="position:absolute;top:0; left:3px;" class="fa ' + self.folderIcon.close + '"></i>');
                var $kin = $('<div class="k-in" style="position:relative; margin-bottom: 14px;margin-top:4px;"></div>');

                $icon.appendTo($kin);
                $textbox.appendTo($kin);
                $(n).empty().append($kin).removeClass('k-state-selected');
                //$(n).empty().append($(icon)).append($textbox).removeClass('k-state-selected');

                var key = function (e) {
                    if (e.keyCode == 27) {
                        $("#dd-id" + self.id).css({ display: "block" });
                        $("#all-id" + self.id).css({ display: "block" });

                        self.state = 0;
                        self.treeview.remove(n);
                    } else if (e.which == 0 || e.which == 13) {
                        var name = $textbox.val();
                        var d = self.treeview.dataItem(s);
                        
                        var dname = name;
                        var ii = 1;
                        var hasD = hasDuplicateName(d.items, name);
                        while (hasD) {
                            if (hasD)
                                dname =  name + '' + ii + '';
                            else
                                break;

                            hasD = hasDuplicateName(d.items, dname);

                            ii++;
                        };

                        name = dname;

                        var cb = {
                            data: {
                                id: d.id,
                                name: name,
                                d: d
                            },
                            success: function (data) {
                                self.state = 0;
                                self.treeview.remove(n);
                                self.treeview.select(self.treeview.append(data, s));
                                redrawMarker(self);
                            },
                            fail: function () {
                                self.state = 0;
                                self.treeview.remove(n);
                                redrawMarker(self);
                            }
                        };

                        callbacks(cb);
                    }                   
                };

                $textbox.focus(function () {
                    $(this).select();
                });
                $textbox.blur(key);
                $textbox.keyup(key);
                $textbox.focus();
            };
            self.nodeRename = function (callbacks) {
                $("#dd-id" + self.id).css({ display: "none" });
                $("#all-id" + self.id).css({ display: "none" });

                self.state = 2;
                var s = self.treeview.select(); if (s.length == 0) return;
                var c = $(s).clone();
                var len = !self.treeview.dataItem(s).text ? 6 : self.treeview.dataItem(s).text.length; len = len < 6 ? 6 : len;
                var $textbox = $('<input class="editnode" type="text" size="'+ len +'" value="' + self.treeview.dataItem(s).text + '">');
                //var icon = '<i class="fa ' + self.folderIcon.open + '"></i>&nbsp;';

                var d = self.treeview.dataItem(s);
                var oldname = d.text;
                var icon = '<i class="fa ' + (d.expanded ? self.folderIcon.open : self.folderIcon.close) + '"></i>&nbsp;';
                
                var key = function (e) {                    
                    if (e.keyCode == 27 || e.type == "blur") {
                        $("#dd-id" + self.id).css({ display: "block" });
                        $("#all-id" + self.id).css({ display: "block" });

                        self.state = 0;
                        $(s).empty().replaceWith(c);
                        
                    } else if (e.which == 0 || e.which == 13) {
                        var name = $textbox.val();
                        //var d = self.treeview.dataItem(s);
                        var id = d.id;

                        //check if no update is needed
                        if (oldname == name) {
                            $("#dd-id" + self.id).css({ display: "block" });
                            $("#all-id" + self.id).css({ display: "block" });

                            self.state = 0;
                            $(s).empty().replaceWith(c);                            

                            return;
                        }
                        
                        //validate only duplicate when old an new is not the same
                        if (oldname.toUpperCase() != name.toUpperCase()) {
                            if (hasDuplicateName((d.parent)(), name)) {
                                //$("#dd-id" + self.id).css({ display: "block" });
                                //$("#all-id" + self.id).css({ display: "block" });

                                return;
                            }
                        }
                        
                        var cb = {
                            data: {
                                id: d.id,
                                name: name,
                                d: d
                            },
                            success: function (dName) {
                                self.state = 0;
                                var docCountText = d.docCount > 0 ? ' (' + d.docCount + ')' : '';
                                var $node = $(icon + '<span class="text">' + name + docCountText + '</span>');
                                $('.k-in.fp-temp', s).empty().append($node).removeClass('fp-temp').addClass('k-state-selected');

                                var itm = self.treeview.dataSource.get(d.id);
                                itm.text = name;
                                if (itm.data && itm.data.name !== undefined) itm.data.name = dName;

                                redrawMarker(self);
                            },
                            fail: function () {
                                self.state = 0;
                                $(s).empty().replaceWith(c);
                            }
                        };

                        callbacks(cb);
                    }
                };

                $('.k-in.k-state-selected', s).empty().append($(icon)).append($textbox).removeClass('k-state-selected').addClass('fp-temp');
                
                $textbox.unbind();
                $textbox.bind("focus", function (e) {
                    $(this).select();
                });
                $textbox.focus();
                $textbox.blur(key);
                $textbox.keyup(key);
            };
            self.nodeRemove = function (callbacks) {
                $("#dd-id" + self.id).css({ display: "none" });
                $("#all-id" + self.id).css({ display: "none" });

                var s = self.treeview.select(); if (s.length == 0) return;
                var d = self.treeview.dataItem(s);
                var id = d.id;
                
                var cb = {
                    data: {
                        id: d.id,
                        name: d.text,
                        d: d
                    },
                    success: function () {
                        self.treeview.remove(s);

                        redrawMarker(self);
                    },
                    fail: function () {

                    }
                };

                callbacks(cb);
            };
            self.nodeSelect = function (n) {
                self.folderActions.showAllDocuments.isSelected(false);

                if (self.settings.data.node && typeof self.settings.data.node.select == 'function') {
                    self.settings.data.node.select(n);
                }
            };
            self.nodeDeselect = function () {
                self.treeview.select($());                
            };
            self.settings.data.getDataSource = function () {
                if (self.treeview)
                    return self.treeview.dataSource;
                else
                    return null;
            };
            self.settings.data.selectNode = function (id, path) {
                if (id == null)
                    return;

                var n = self.treeview.dataSource.get(id);
                if (!n)
                    return;

                var node = self.treeview.findByUid(n.uid);
                var ids = [];

                self.treeview.select(node);

                _travelNode(node);

                ids.pop();

                self.treeview.expandPath(ids);

                redrawMarker(self);

                self.nodeSelect(n);

                function _travelNode(n) {
                    ids.unshift(self.treeview.dataItem(n).id);

                    var n0 = self.treeview.parent(n);
                    
                    if (n0.length == 0)
                        return;

                    _travelNode(n0);
                }
            };
            self.settings.data._updateNode = function (id, data) {
                if (id == null || !data)
                    return;

                var n = self.treeview.dataSource.get(id);
                
                if (!n)
                    return;

                n.text = data.text || n.text; //n.data.name(text);
                n.docCount = data.docCount || n.docCount;
                n.data.docCount = data.docCount || n.data.docCount;

                var docCountText = data.docCount  > 0 ? ' (' + data.docCount + ')' : '';
                var node = self.treeview.findByUid(n.uid).find("span:has(span) > span");
                
                if (node.length > 0) {
                    $(node[0]).text(data.text + docCountText);
                    
                    if (n) {
                        n.docCount = data.docCount;

                        if (n.data) {
                            n.data.docCount = data.docCount;
                            n.data.documentCount = data.docCount;
                        }
                    }
                }
                //node.find("span.k-state-selected > span").text(data.text + docCountText);

                redrawMarker(self);
            };
            self.collapseExpand = function () {
                self.isCollapsingExpanding = true;

                if (self.isCollapsible()) {
                    self.treeview.collapse(".k-item .k-item");                    

                    redrawMarker(self);

                } else {
                    //self.treeview.expand(".k-item:first");   

                    self.treeview.expand(".k-item");
                    
                    var i = 0;
                    var ii = self.$treeview.find(".k-item .k-item:has(span.k-plus)").length;

                    while (ii > 0) {
                        ii = self.$treeview.find(".k-item .k-item:has(span.k-plus)").length;

                        self.treeview.expand(".k-item");
                        i++;

                        if (i > 100)
                            break;
                    }

                    redrawMarker(self);
                }

                self.isCollapsingExpanding = false;
            };

            self.folderActions = self.settings.data.folderActions;
            self.folderActions.treeNode = self.settings.data.node;            

            self.settings.data.loadBegin = function () {
                self.isCollapseExpandVisible(false);
                self.isCollapsingExpanding = false;
                
                if (self.treeview) {
                    $("#dd-id" + self.id).css({ display: "none" });
                    $("#all-id" + self.id).css({ display: "none" });
                }
            }
            self.loadEnd = function () {                
                self.isCollapsingExpanding = false;                                

                if (self.treeview) {
                    self.isCollapseExpandVisible(self.treeview.dataSource.data().length);

                    if (!self.treeview.select().length) {
                        $("#dd-id" + self.id).css({ display: "none" });
                        $("#all-id" + self.id).css({ display: "none" });
                    } else {                        
                        $("#dd-id" + self.id).css({ display: "block" });
                        $("#all-id" + self.id).css({ display: "block" });                        
                    }                  
                }
            };
            
            self.dataSource = self.settings.data.getTreeviewDataSource(self.loadEnd);
        };

        ctor.prototype.attached = function () {
            var self = this;
            var folderIcon = '(item.expanded ? "' + self.folderIcon.open + '" : "' + self.folderIcon.close + '")';            
            var template = '<i class="fa #=' + folderIcon + '#"></i>&nbsp;<span>#: item.text # #: (item.docCount == undefined || item.docCount == "0" || item.docCount == "") ? " " : "(" + item.docCount + ")" #</span>';

            self.$treeview = $('#treeview' + self.id);
            self.treeview = self.$treeview.kendoTreeView({
                animation: {
                    collapse: false,
                    expand: false,
                },
                loadOnDemand: false,
                template: template,
                dataSource: self.dataSource,
                select: function (e) {
                    
                    if (self.state != 0) {
                        return;
                    }

                    var item = this.dataItem(e.node);

                    self.nodeSelect(item);

                    markNode(self, e.node);
                },
                expand: function (e) {
                    var el = $(':first', e.node).find('i.' + self.folderIcon.close);

                    el.removeClass(self.folderIcon.close);
                    el.addClass(self.folderIcon.open);

                    setTimeout(function () {
                        self.showCollapsed(!self.isCollapsible() ? self.folderIcon.close : self.folderIcon.open);
                    }, 10);

                    if (!self.isCollapsingExpanding) {
                        $("#dd-id" + self.id).css({ display: "none" });
                        $("#all-id" + self.id).css({ display: "none" });
                        setTimeout(function() {
                            redrawMarker(self);
                        }, 5);
                    }
                },
                collapse: function (e) {
                    var el = $(':first', e.node).find('i.' +self.folderIcon.open);

                    el.removeClass(self.folderIcon.open);
                    el.addClass(self.folderIcon.close);

                    setTimeout(function () {
                        self.showCollapsed(!self.isCollapsible() ? self.folderIcon.close: self.folderIcon.open);
                    }, 10);

                    if (!self.isCollapsingExpanding) {
                        $("#dd-id" + self.id).css({ display: "none" });
                        $("#all-id" + self.id).css({ display: "none" });
                        setTimeout(function () {
                            redrawMarker(self);
                        }, 5);
                    }
                }
            }).data('kendoTreeView');

            self.settings.data.node.rename = self.nodeRename;
            self.settings.data.node.add = self.nodeAdd;
            self.settings.data.node.remove = self.nodeRemove;
            self.settings.data.deselect = self.nodeDeselect;

            self.initialized(true);

            var _prev_id = "";

            self.$treeview.on('mousedown', '.k-item', function (e) {
                if (e.which === 3) {
                    e.stopPropagation();

                    setTimeout(function () {
                        if (!$("#dd-id" + self.id + " ul.dropdown-menu").is(":visible")) {
                            $("#dd-id" + self.id + " a[data-toggle='dropdown']").trigger("click");
                        }
                        //console.warn($("#dd-id" + self.id + " ul.dropdown-menu").is(":visible"));
                    }, 500);

                    if (self.state != 0) {
                        return;
                    }

                    self.treeview.select(this);

                    var item = self.treeview.dataItem(self.treeview.select());

                    if (item.id == _prev_id) {
                        return;
                    }

                    _prev_id = item.id;

                    self.nodeSelect(item);

                    markNode(self, self.treeview.select());
                }
            })
        };

        ctor.prototype.copyLink = function () {
            copyTextToClipboard(sessionStorage.__url, "Folder link copied");

            function copyTextToClipboard(text, msg) {
                var textArea = document.createElement("textarea");

                // Place in top-left corner of screen regardless of scroll position.
                textArea.style.position = 'fixed';
                textArea.style.top = 0;
                textArea.style.left = 0;
                // Ensure it has a small width and height. Setting to 1px / 1em
                // doesn't work as this gives a negative w/h on some browsers.
                textArea.style.width = '2em';
                textArea.style.height = '2em';
                // We don't need padding, reducing the size if it does flash render.
                textArea.style.padding = 0;
                // Clean up any borders.
                textArea.style.border = 'none';
                textArea.style.outline = 'none';
                textArea.style.boxShadow = 'none';
                // Avoid flash of white box if rendered for any reason.
                textArea.style.background = 'transparent';
                textArea.style.resize = "none";
                textArea.value = text;
                textArea.style.overflow = "hidden";
                textArea.style.zIndex = "1";

                document.body.appendChild(textArea);

                textArea.select();

                try {
                    var successful = document.execCommand('copy');
                    //var msg = successful ? 'successful' : 'unsuccessful';
                    //console.warn('Copying text command was ' + msg);

                    if (successful) {
                        toastr.success(!msg ? "Address link copied." : msg);
                    }
                } catch (e) {
                    console.error(e);

                    toastr.error(e);
                }

                document.body.removeChild(textArea);
            }
        };

        return ctor;

        function redrawMarker(self) {
            var node = self.treeview.select();
            if ($(node).is(":visible")) {
                markNode(self, node);
            } else {
                $("#dd-id" + self.id).css({ display: "none" });
                $("#all-id" + self.id).css({ display: "none" });
            }
        }
        function markNode(self, node) {
            var p = self.$treeview.find("#_dd" + self.id); //$('#treeview' + self.id + '').find(".k-state-selected").next();

            if (p.length) {
                p.remove();
            }

            $("> div", node).append('<i id="_dd' + self.id + '"></i>');

            var s = self.$treeview.find("#_dd" + self.id);
            var n = $("#dd-id" + self.id);
            var all = $("#all-id" + self.id);

            n.parent().css({ position: 'relative' });

            var t = s.offset().top - self.$treeview.parent().offset().top;
            var l = s.offset().left;

            var $textbox = $("input.editnode");
            if ($textbox.length > 0) {
                l = l + $textbox.width();
            }

            n.css({ top: t, left: l, position: 'absolute' });
            all.css({ top: t, left: l + 20, position: 'absolute' });
            
            var g = n.find("ul");
            if (l < 140) {
                g.removeClass("pull-right");
                g.addClass("pull-left");
            } else {
                g.removeClass("pull-left");
                g.addClass("pull-right");
            }

            //console.warn(window.innerHeight - s.offset().top);

            if(window.innerHeight - s.offset().top < 250)
                n.addClass("dropup");
            else
                n.removeClass("dropup");

            n.css({ display: "block" });
            all.css({ display: "block" });
        }
        function hasDuplicateName(names, name) {
            if (names.length == 0 || name.length == 0) return false;

            var w = _.chain(names)
                .pluck('text')
                .without(undefined)
                .map(function (itm) { return { text: itm.toLowerCase() } })
                .where({ text: name.toLowerCase() })
                .value();
            
            return w.length;
        }
    });
